import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CargadorPcPage } from './cargador-pc';
import { DirectivesModule } from '../../../directives/directives.module';
import { PipesModule } from '../../../pipes/pipes.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    CargadorPcPage,
  ],
  imports: [
    IonicPageModule.forChild(CargadorPcPage),
    DirectivesModule,
    PipesModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class CargadorPcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/cargador-pc/cargador-pc.module.ts